import SelectComponent from "components/select/Select";
import ChartWeekMonth from "./ChartWeekMonth";
import { useTranslation } from "react-i18next";
import DatePickerComponent from "components/datepicker/Datepicker";
import "./styles.scss";
import ButtonComponent from "components/button/Button";
import { Col, Row } from "antd";
import { CaretDownOutlined } from "@ant-design/icons";
import { useState, useEffect } from "react";
import {
  TYPE_DATE_OPTIONS,
  TYPE_DATE_OPTIONS_VALUE,
} from "pages/graph/constants";
import ChartDay from "./chart-day";
import { apiGetChartData } from "helpers/api/records";
import { useParams } from "react-router-dom/cjs/react-router-dom.min";
import moment from "moment";
import dayjs from "dayjs";
import Loading from "components/loading/Loading";

const ChartTemperature = ({ patientId, dateSelected, setDateSelected }) => {
  const { id } = useParams();
  const { t } = useTranslation();
  const [startDate, setStartDate] = useState(new Date());
  const [startDateSelected, setStartDateSelected] = useState(new Date());
  const [typeDate, setTypeDate] = useState(TYPE_DATE_OPTIONS_VALUE.day);
  const [dataSleep, setDataSleep] = useState([]);
  const [dataTemperature, setDataTemperature] = useState([]);
  const [dataEvent, setDataEvent] = useState([]);
  const [chartType, setChartType] = useState(TYPE_DATE_OPTIONS_VALUE.day);
  const [dataWeekMonth, setDataWeekMonth] = useState({});
  const [isLoading, setIsLoading] = useState(false);
  const [categories, setCategories] = useState([]);
  const [endDate, setEndDate] = useState(startDate);

  useEffect(() => {
    handleClickGetData();
  }, [])

  useEffect(() => {
    handleClickGetData();
  }, [startDate])

  const handleChangeTypeDate = (val) => {
    setTypeDate(val)
  }

  const handleClickGetData = () => {
    setIsLoading(true);
    setChartType(typeDate);
    setDateSelected(dayjs(startDate));
    let to = startDate;

    if (
      startDate &&
      [TYPE_DATE_OPTIONS_VALUE.week, TYPE_DATE_OPTIONS_VALUE.month].includes(
        typeDate
      )
    ) {
      const numberOfDay = typeDate === TYPE_DATE_OPTIONS_VALUE.week ? 7 : 30;
      let currentDate = dayjs(startDate);
      const newCategories = [currentDate.format("YYYY-MM-DD")];
      for (let i = 1; i < numberOfDay; i++) {
        currentDate = currentDate.add(1, "day");
        newCategories.push(currentDate.format("YYYY-MM-DD"));
      }
      setCategories(newCategories);
    }

    if (typeDate === TYPE_DATE_OPTIONS_VALUE.week) {
      setEndDate(moment(startDate).add(6, 'd'));
      to = moment(startDate).add(6, 'd');
    } else if (typeDate === TYPE_DATE_OPTIONS_VALUE.month) {
      setEndDate(moment(startDate).add(29, 'd'));
      to = moment(startDate).add(29, 'd');
    } //else {
    //   setEndDate(startDate);
    // }
    apiGetChartData(id, {
      from: moment(startDate).format('YYYY-MM-DD'),
      // to: moment(endDate).format('YYYY-MM-DD')})
      to: moment(to).format('YYYY-MM-DD')
    })
      .then((resp) => {
        if (resp.data) {
          // Data for chart day
          setDataSleep(resp.data.map(item => ({
            dateTime: item.date_time,
            value: item.value_slide,
            type: item.type_sleep
          })));
          setDataTemperature(resp.data.map(item => ({ dateTime: item.date_time, value: item.temp })))
          setDataEvent(resp.records);

          // Data for chart week/month
          const groupedDataByDate = resp.data.reduce((item, obj) => {
            const key = moment(new Date(obj.date_time)).format('YYYY-MM-DD');
            if (!item[key]) {
              item[key] = [];
            }
            item[key].push(obj);
            return item;
          }, {})

          const temperature = [];
          const sleepData = [];
          for (const key in groupedDataByDate) {
            temperature[key] = calculateAverage(groupedDataByDate[key], 'temp');
            sleepData[key] = countBy(groupedDataByDate[key], 'type_sleep');
          }

          const faceUp = [];
          const faceDown = [];
          for (const key in sleepData) {
            faceUp[key] = sleepData[key].SLEEP_FACE_UP;
            faceDown[key] = sleepData[key].SLEEP_FACE_DOWN;
          }

          setDataWeekMonth({
            temperature: temperature,
            faceUp: faceUp,
            faceDown: faceDown,
          })
          setIsLoading(false);
        }
      }).catch((err) => {
        setIsLoading(false);
        console.log(err);
      });
  }

  const calculateAverage = (arr, key) => {
    const sum = arr.reduce((total, obj) => total + obj[key], 0);
    const average = sum / arr.length;

    return parseFloat(average.toFixed(2));

  }

  const countBy = (arr, key) => {
    return arr.reduce((result, current) => {
      // Extract the value for the given key
      const value = current[key];

      // If the value exists in the result, increment its count
      if (result[value]) {
        result[value]++;
      } else {
        // If the value does not exist in the result, initialize it to 1
        result[value] = 1;
      }
      return result;
    }, {}); // Initial value of result is an empty object
  }

  return (
    <div className="chart-temperature-container">
      <div className="chart-select-date">
        <div className="chart-date-type">
          <Row style={{ width: "100%" }}>
            <Col span={14}>
              <DatePickerComponent
                // prefix="calendar-gray.png"
                suffixIcon={
                  <CaretDownOutlined
                    style={{ fontSize: "20px", color: "#737373" }}
                  />
                }
                placeholder={"YYYY-MM-DD"}
                format="YYYY-MM-DD"
                name="date"
                value={startDateSelected}
                // error={errors?.date}
                onChange={(e) => setStartDateSelected(new Date(e))}
              />
            </Col>
            <Col span={2} className="icon-between">
              ~
            </Col>
            <Col span={8}>
              <SelectComponent
                suffixIcon={
                  <CaretDownOutlined
                    style={{ fontSize: "20px", color: "#737373" }}
                  />
                }
                options={TYPE_DATE_OPTIONS}
                name="gender"
                value={typeDate}
                onChange={handleChangeTypeDate}
              />
            </Col>
          </Row>
        </div>
        <ButtonComponent
          background="#035697"
          className="select-date-button"
          text={t("search")}
          type="button"
          onClick={() => {
            if (startDateSelected != startDate) {
              setStartDate(startDateSelected)
            } else {
              handleClickGetData()
            }
          }}
        />
      </div>
      {chartType === TYPE_DATE_OPTIONS_VALUE.day ? (
        <ChartDay
          dataSleep={dataSleep}
          dataTemperature={dataTemperature}
          dataEvent={dataEvent}
          startDate={startDate}
          patientId={patientId}
          dateSelected={dateSelected}
        />
      ) : (
        <ChartWeekMonth
          data={dataWeekMonth}
          categories={categories}
          startDate={startDate}
          endDate={endDate}
          patientId={patientId}
          dateSelected={dateSelected}
          chartType={chartType}
        />
      )}
      {isLoading && <Loading />}
    </div>
  );
};

export default ChartTemperature;
